import { filter } from 'lodash'

/**
 * @var {ApiMiddleware}
 */
let api = {}

/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setCommentApiMiddleware = middlewareObject => {
    api = middlewareObject
}

export default () => ({
    state: {
        comments: [],
    },
    getters: {
        commentsForEntity: state => id => filter(state.comments, { 'entity': id }),
        comments: state => state.comments,
    },
    mutations: {
        setComments: (state, comments) => {
            state.comments = comments
        },
        addComment: (state, newComment) => {
            state.comments.push(newComment)
        },
    },
    actions: {
        async commentsLoad({ commit }) {
            const comments = await api.get('/comment')
            commit('setComments', comments)
        },
        async addComment({}, data) {
            await api.post('/comment', data)
        },
    },
})
